import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: '/customer_api/',
  timeout: 20000
})

axiosInstance.defaults.withCredentials = true

export default axiosInstance



// WEBPACK FOOTER //
// ./src/api.js